function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Panel from './Panel';
import { Flex, Heading, Icon, Stack, Text } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
function SettingsPanel(_param, ref) {
    var icon = _param.icon, heading = _param.heading, description = _param.description, afterElement = _param.afterElement, afterElementContainerProps = _param.afterElementContainerProps, props = _object_without_properties(_param, [
        "icon",
        "heading",
        "description",
        "afterElement",
        "afterElementContainerProps"
    ]);
    return /*#__PURE__*/ _jsxs(Panel, _object_spread_props(_object_spread({
        as: Flex,
        gap: 4,
        padding: 4,
        alignItems: "center",
        ref: ref
    }, props), {
        children: [
            icon != null ? /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: icon,
                backgroundColor: "borderSecondary",
                padding: 3,
                borderRadius: "md"
            }) : null,
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: "2px",
                isTruncated: true,
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        isTruncated: true,
                        size: "xs",
                        children: heading
                    }),
                    description != null ? /*#__PURE__*/ _jsx(Text, {
                        isTruncated: true,
                        color: "textSecondary",
                        fontSize: "sm",
                        fontWeight: "normal",
                        children: description
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(Flex, _object_spread_props(_object_spread({
                justifyContent: "right",
                width: "100%",
                maxWidth: "200px",
                marginLeft: "auto"
            }, afterElementContainerProps), {
                children: afterElement
            }))
        ]
    }));
}
export default /*#__PURE__*/ React.forwardRef(SettingsPanel);
